import {createSelector} from 'reselect';

const directDownloadSelector = (state) => state.downloads;

export const selectDownloadIds = createSelector(
    [directDownloadSelector],
    (downloads) => downloads.downloadIds
);